import {
  BasicProps as BaseFooterProps,
  Footer as BaseFooter,
} from 'antd/lib/layout/layout'

export interface FooterProps extends BaseFooterProps {}

export const Footer = (props: FooterProps): JSX.Element => (
  <>
    <BaseFooter {...props} />
  </>
)
